import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _discountTypeLabelMap;

import { DiscountType, SubscriptionType } from '@atlassian/mpac-api-client';
export var Stages = Object.freeze({
  PROMOTION_BASICS: 1,
  DISCOUNT_AMOUNT: 2,
  ELIGIBILITY_CRITERIA: 3,
  PROMOTION_SUMMARY: 4
});
export var subscriptionTypesOptions = [{
  label: 'Monthly',
  value: SubscriptionType.MONTHLY
}, {
  label: 'Annual',
  value: SubscriptionType.ANNUAL
}];
export var DiscountAmountStageDefaultValues = Object.freeze({
  FLAT_DISCOUNT: 25,
  SUBSCRIPTION_TYPE: subscriptionTypesOptions[0]
}); // FORM ERRORS

export var FIELD_EMPTY_ERROR = 'FIELD_EMPTY_ERROR';
export var ELIGIBLE_APPS_MISMATCH_ERROR = 'ELIGIBLE_APPS_MISMATCH_ERROR';
export var ELIGIBLE_APPS_HOSTING_TYPE_MISMATCH_ERROR = 'ELIGIBLE_APPS_HOSTING_TYPE_MISMATCH_ERROR';
export var discountTypeLabelMap = (_discountTypeLabelMap = {}, _defineProperty(_discountTypeLabelMap, DiscountType.TIERED_DISCOUNT, 'Tiered'), _defineProperty(_discountTypeLabelMap, DiscountType.FLAT_DISCOUNT, 'Flat'), _discountTypeLabelMap);
export var PromotionListSectionMessageActions = Object.freeze({
  ADD: 'add',
  END_PROMOTION: 'end'
});